import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

const ModalContentWrapper = styled(Box)({
	maxWidth: '380px',
	margin: '0 auto',
});

export default ModalContentWrapper;
